import pageStore from 'stores/ReperksWidget/PageStore';
import * as widgetUtils from 'stores/ReperksWidget/Utils';
import * as utils from 'Utils';

function getReperksWidgetHandler(app) {
  const handler = {};

  handler.showPanel = (nav) => {
    if (nav) pageStore.switchNav(nav);
    pageStore.switchPanel();
  };

  handler.hidePanel = () => {
    pageStore.switchLauncher();
  };

  handler.onReady = (callback) => {
    pageStore.setOnReadyCallback(callback);
  };

  handler.getMemberData = (callback) => {
    let member = pageStore.member;
    return callback(member.getData());
  };

  // TODO: Remove this later on
  handler.reloadWithMember = (memberExternalId) => {
    pageStore.setMemberExternalId(memberExternalId);
    app.loadReperksWidget();
  };

  return handler;
}

// process all queued function calls `apiReady`
export default function apiReady(app) {
  const handler = getReperksWidgetHandler(app);

  const process = (args) => {
    var params = [].slice.call(args);
    var ns = params.shift();
    var method = params.shift();

    // reperks_widget namespace
    if (ns === "reperks_widget") {
      if (handler[method]) {
       handler[method].apply(handler, params);
      } else {
        console.log(`reperks_widget does not have a ${method} method`);
      }
    }
  };

  if (!window.OnVoardQueue) window.OnVoardQueue = {};
  if (!window.OnVoardApi) window.OnVoardApi = {};

  // process queued function calls
  const queue = window.OnVoardQueue.reperksWidget || [];
  for (var i in queue) {
    process(queue[i]);
  }

  // setup api endpoint after everything is ready
  window.OnVoardApi.reperksWidget = function(args) {
    process(args);
  };

  // this is to support testing api in dev
  if (!utils.isProduction()) {
    window.OnVoard = function() {
      process(arguments);
    };
  }
}
